// from C# model
// public enum SchemaType
// 	{
// 		Undefined = 0,
// 		Video,
// 		Graphics,
// 		Image
// 	}
export enum SchemaType {
  Video = 'Video',
  Graphics = 'Graphics',
  Image = 'Image',
}

export interface SchemaTypeOption {
  id: SchemaType;
  schemaName: string;
}

export const SchemaTypeOptions: SchemaTypeOption[] = [
  { id: SchemaType.Video, schemaName: 'Video' },
  { id: SchemaType.Graphics, schemaName: 'Transition' },
  { id: SchemaType.Image, schemaName: 'Image' },
];
